import React from 'react';
import { Navigate, useLocation } from 'react-router';
import { useAuthenticationStatus } from '@nhost/react';
import { Flex, Spinner, Text, useColorModeValue } from '@chakra-ui/react';

interface ProtectedRouteProps {
  children: React.ReactElement;
  adminOnly?: boolean;
}

const ProtectedRoute = (props: ProtectedRouteProps) => {
  const { children } = props;

  const { isAuthenticated, isLoading } = useAuthenticationStatus();
  const location = useLocation();
  
  const bgColor = useColorModeValue('white', 'gray.800');
  const textColor = useColorModeValue('gray.700', 'white');
  const accentColor = useColorModeValue('brand.500', 'brand.300');

  if (isLoading) {
    return (
      <Flex 
        minH="100vh" 
        align="center" 
        justify="center" 
        bg={bgColor}
        direction="column"
      >
        <Spinner 
          thickness="4px"
          speed="0.65s"
          emptyColor="gray.200"
          color={accentColor}
          size="xl"
        />
        <Text mt={4} fontSize="lg" color={textColor}>
          Authenticating...
        </Text>
      </Flex>
    );
  }

  if (isAuthenticated) {
    return children;
  }

  return <Navigate to="/" state={{ from: location }} replace />;
};

export default ProtectedRoute;
